/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VehicleMovementPeriodList
 */
export interface VehicleMovementPeriodList {
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMovementPeriodList
     */
    eventId: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMovementPeriodList
     */
    vehicleSerialNumber: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof VehicleMovementPeriodList
     */
    userEmployeeId: boolean;
}

/**
 * Check if a given object implements the VehicleMovementPeriodList interface.
 */
export function instanceOfVehicleMovementPeriodList(value: object): value is VehicleMovementPeriodList {
    if (!('eventId' in value) || value['eventId'] === undefined) return false;
    if (!('vehicleSerialNumber' in value) || value['vehicleSerialNumber'] === undefined) return false;
    if (!('userEmployeeId' in value) || value['userEmployeeId'] === undefined) return false;
    return true;
}

export function VehicleMovementPeriodListFromJSON(json: any): VehicleMovementPeriodList {
    return VehicleMovementPeriodListFromJSONTyped(json, false);
}

export function VehicleMovementPeriodListFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleMovementPeriodList {
    if (json == null) {
        return json;
    }
    return {
        
        'eventId': json['eventId'],
        'vehicleSerialNumber': json['vehicleSerialNumber'],
        'userEmployeeId': json['userEmployeeId'],
    };
}

export function VehicleMovementPeriodListToJSON(json: any): VehicleMovementPeriodList {
    return VehicleMovementPeriodListToJSONTyped(json, false);
}

export function VehicleMovementPeriodListToJSONTyped(value?: VehicleMovementPeriodList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventId': value['eventId'],
        'vehicleSerialNumber': value['vehicleSerialNumber'],
        'userEmployeeId': value['userEmployeeId'],
    };
}

